type ErrorHandler = (error: Error) => Promise<any> | void;

export interface SdkSettings {
  baseUrl?: string;
  abortMethodName?: string;
  productType: string;
  errorHandler?: ErrorHandler;
}

export default class SettingsManager {
  constructor(private readonly settings: SdkSettings) {
    this.settings = { ...settings };
  }

  getBaseUrl = (): string => {
    return this.settings.baseUrl || '';
  };

  getProductType = (): string => {
    return this.settings.productType || '';
  };

  getErrorHandler = (): ErrorHandler | undefined => {
    return this.settings.errorHandler;
  };

  getAbortMethodName = (): string | undefined => {
    return this.settings.abortMethodName;
  };

  setErrorHandler = (errorHandler: ErrorHandler) => {
    this.settings.errorHandler = errorHandler;
  };
}
